import { hiddenModeRefusal } from "../validations";
import { readHidden, writeHidden } from "../visibility";
import type { CustomizationHandler } from "./types";

/**
 * The variant selector of the product page's add-to-cart form.
 *
 * `.js-product-variants` wraps every variation group in all SDK-carrying
 * themes, and the themes' own JS relies on it. The `data-store="product-detail"`
 * scope leaves out the quick shop, grid cards and the home's main product
 * (`home-product-main`). new_linkedman has no such root, so it falls back to
 * `#product_form`, scoped to that theme because most themes use that id.
 *
 * Products without variations render no selector: `not_found`. Hiding keeps
 * the selects in the form, so the selected variant is still submitted.
 *
 * @see ./README.md
 */
export const productDetailVariants: CustomizationHandler<"product-detail-variants"> =
	{
		host: "storefront",
		selector:
			'[data-store="product-detail"] .js-product-variants, body.js-nubesdk-theme-new_linkedman #product_form .js-product-variants',

		read(element) {
			return { hidden: readHidden(element) };
		},

		operation(element, options) {
			if (options.hidden !== undefined) writeHidden(element, options.hidden);
		},

		values(element) {
			return { hidden: readHidden(element) };
		},

		validate(_element, options) {
			if (options.hidden !== undefined) {
				const refusal = hiddenModeRefusal(options.hidden);
				if (refusal) return `refused "hidden": ${refusal}`;
			}

			return null;
		},
	};
